module.exports = __webpack_public_path__ + "assets/images/invisible-asia-logo.jpg?v=14281291";